"use client";

import { ToastProps } from "@/stores/toastStore";
import { Icon } from "@iconify/react";
import clsx from "clsx";
import { Toast } from "flowbite-react";
import { useEffect } from "react";
import { useToastStore } from "../providers/stores/ToastStoreProvider";
const borderColors: Record<ToastProps["color"], string> = {
  success: "border-success-600",
  destructive: "border-destructive-400",
  warning: "border-warning-500",
  info: "border-neutral-900"
};
const iconBGColors: Record<ToastProps["color"], string> = {
  success: "bg-success-50",
  destructive: "bg-destructive-50",
  warning: "bg-warning-50",
  info: "bg-neutral-200"
};
const iconColors: Record<ToastProps["color"], string> = {
  success: "text-success-600",
  destructive: "text-destructive-400",
  warning: "text-warning-500",
  info: "text-neutral-900"
};
const icons: Record<ToastProps["color"], string> = {
  success: "bi:check-lg",
  destructive: "bi:bell",
  warning: "bi:exclamation",
  info: "bi:bell"
};
type Props = {
  toastQueue: ToastProps[];
  removeToastFromQueue: (id: string) => void;
};
export function DisconnectedToasts({
  toastQueue,
  removeToastFromQueue
}: Props) {
  return <div className={`fixed right-12 bottom-12 flex flex-col-reverse gap-4 items-stretch z-50`} data-sentry-component="DisconnectedToasts" data-sentry-source-file="Toasts.tsx">
      {toastQueue?.map((toast, index) => <Toast key={toast.id || index} className={clsx("basis-full min-w-fit w-full max-w-full gap-4 border-l-1.5 ", borderColors[toast.color])}>
          <div className={clsx(`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg`, iconBGColors[toast.color], iconColors[toast.color])}>
            <Icon icon={toast.icon || icons[toast.color]} className="w-5 h-5" />
          </div>
          <div className="text-sm font-normal whitespace-nowrap">
            {toast.message}
          </div>
          <Toast.Toggle onClick={() => removeToastFromQueue(toast.id || "")} className="ml-auto" />
        </Toast>)}
    </div>;
}
export default function Toasts() {
  const {
    toastQueue,
    removeToastFromQueue
  } = useToastStore(state => state);
  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (toastQueue.length > 0) {
      interval = setInterval(() => {
        toastQueue.forEach(toast => {
          if (toast.timestamp && Date.now() - toast.timestamp > 5000) {
            removeToastFromQueue(toast.id || "");
          }
        });
      }, 1000);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [toastQueue, removeToastFromQueue]);
  return <DisconnectedToasts toastQueue={toastQueue} removeToastFromQueue={removeToastFromQueue} data-sentry-element="DisconnectedToasts" data-sentry-component="Toasts" data-sentry-source-file="Toasts.tsx" />;
}